import React, { useState, useEffect } from 'react';
import styles from './cell.module.scss';
import plus from '../../Assets/Images/Icons/Other/plus.png';
import minus from '../../Assets/Images/Icons/Other/minus.png';

const Cell = ({ label, required, value = null, rowsCount = 2, columnsCount = 3, onChange }) => {
    // Initialize rows from JSON data or generate a blank table
    const generateInitialRows = () => {
        if (value && value.length) return [...value]; // Use provided JSON data
        return Array.from({ length: rowsCount }, () => Array(columnsCount).fill('')); // Generate empty table
    };

    const [rows, setRows] = useState(generateInitialRows());

    useEffect(() => {
        setRows(generateInitialRows());
    // eslint-disable-next-line
    }, [rowsCount, columnsCount]);

    // Notify the parent component whenever the table updates
    useEffect(() => {
        onChange(rows);
    // eslint-disable-next-line
    }, [rows]);

    const getColumnCount = () => (rows.length > 0 ? rows[0].length : 0);

    const addColumn = () => {
        setRows(rows.map(row => [...row, '']));
    };

    const addRow = () => {
        setRows([...rows, Array(getColumnCount()).fill('')]);
    };

    const deleteLastColumn = () => {
        if (getColumnCount() > 2) {
            setRows(rows.map(row => row.slice(0, -1)));
        }
    };

    const deleteLastRow = () => {
        if (rows.length > 2) {
            setRows(rows.slice(0, -1));
        }
    };

    const handleCellChange = (rowIndex, colIndex, value) => {
        const newRows = [...rows];
        newRows[rowIndex][colIndex] = value;
        setRows(newRows);
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const clipboardData = e.clipboardData.getData('text');
    
        const parsedRows = clipboardData
            .trim()
            .split('\n')
            .map(row => row.split('\t').map(cell => cell.trim()));
    
        const maxCols = Math.max(...parsedRows.map(r => r.length));
        const newRows = [...rows];
    
        // Resize the table if needed
        while (newRows.length < parsedRows.length) {
            newRows.push(Array(getColumnCount()).fill(''));
        }
    
        newRows.forEach((existingRow, i) => {
            const newRow = parsedRows[i] || [];
            while (existingRow.length < maxCols) {
                existingRow.push('');
            }
            newRow.forEach((val, j) => {
                existingRow[j] = val;
            });
        });
    
        setRows(newRows);
    };

    return (
        <div className={styles.container}>

            <p>
                {required ? '*' : null}
                <b>{label}</b>
            </p>

            <div className={styles.tableController}>
                <div className={styles.tableControllerButtons}>
                    <img src={minus} onClick={deleteLastColumn} alt='minus' />
                    <h4>Column</h4>
                    <img src={plus} onClick={addColumn} alt='plus' />
                </div>

                <div className={styles.tableControllerButtons}>
                    <img src={minus} onClick={deleteLastRow} alt='minus' />
                    <h4>Row</h4>
                    <img src={plus} onClick={addRow} alt='plus' />
                </div>
            </div>

            <div className={styles.tableLineItems}>
                <table>
                    <tbody>
                        {rows.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {row.map((cell, colIndex) => (
                                    <td key={colIndex}>
                                        <input
                                            type='text'
                                            value={cell}
                                            onChange={(e) => handleCellChange(rowIndex, colIndex, e.target.value)}
                                            onPaste={handlePaste}
                                        />
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Cell;
